// GA4 이벤트 전송. 측정 ID가 없는 빌드(로컬 등)에서는 gtag가 없으므로 아무것도 하지 않는다.
export const trackEvent = (name, params = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
};
